"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUploadSchema = exports.getDownloadSchema = exports.getScliptListSchema = void 0;
const getScliptListSchema = ({ langId, }) => ({
    schemaType: "object",
    properties: [
        {
            title: "ID",
            propertyName: "scriptId",
            schema: {
                schemaType: "text",
                required: true,
            },
            width: "1%",
        },
        {
            title: "テキスト",
            propertyName: "text",
            schema: {
                schemaType: "text",
            },
        },
        ...(langId
            ? [
                {
                    title: "翻訳文",
                    propertyName: `translations.${langId}`,
                    schema: {
                        schemaType: "text",
                    },
                },
                {
                    title: "Status",
                    propertyName: `translationStatus.${langId}`,
                    schema: {
                        schemaType: "selector",
                        options: [
                            {
                                value: null,
                                title: "未着手",
                            },
                            {
                                value: "updated",
                                title: "更新",
                            },
                            {
                                value: "translated",
                                title: "翻訳済み",
                            },
                            {
                                value: "corrected",
                                title: "校閲済み",
                            },
                        ],
                    },
                    width: "1%",
                },
                {
                    title: "参照訳に利用",
                    tooltip: "このテキストを参照訳として利用します",
                    propertyName: `translationIgnore.${langId}`,
                    schema: {
                        schemaType: "boolean",
                        invert: true,
                    },
                    width: "1%",
                },
                {
                    title: "未解決コメント数",
                    propertyName: "unresolvedComment",
                    schema: { schemaType: "text" },
                    width: "1%",
                },
            ]
            : []),
    ],
});
exports.getScliptListSchema = getScliptListSchema;
const getDownloadSchema = ({ isMaster, }) => ({
    schemaType: "object",
    properties: [
        {
            title: "出力形式",
            propertyName: "fileFormat",
            schema: {
                schemaType: "selector",
                required: true,
                options: [
                    {
                        title: "Excel",
                        value: "xlsx",
                    },
                    {
                        title: "CSV",
                        value: "csv",
                    },
                ],
            },
        },
        ...(isMaster
            ? [
                {
                    title: "IDを変換する",
                    propertyName: "isConvertId",
                    schema: {
                        schemaType: "boolean",
                    },
                },
                {
                    title: "単数選択を変換する",
                    propertyName: "isConvertSelector",
                    schema: {
                        schemaType: "boolean",
                    },
                },
                {
                    title: "複数選択を展開する",
                    propertyName: "isExpandMultipleSelector",
                    schema: {
                        schemaType: "boolean",
                    },
                },
                {
                    title: "表示名を追加する",
                    propertyName: "isJoinMaster",
                    schema: {
                        schemaType: "boolean",
                    },
                },
                {
                    title: "ヘッダーを1行のみ出力する",
                    propertyName: "isMinHeader",
                    schema: {
                        schemaType: "boolean",
                    },
                },
                {
                    title: "すべての項目をダウンロードする",
                    propertyName: "forceUseRealFields",
                    schema: {
                        schemaType: "boolean",
                    },
                },
            ]
            : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                []),
    ],
});
exports.getDownloadSchema = getDownloadSchema;
const getUploadSchema = () => ({
    schemaType: "object",
    properties: [
        {
            title: "CSVテキスト(タブ区切り）",
            propertyName: "uploadCsvData",
            schema: {
                schemaType: "multilineText",
            },
        },
        {
            title: "CSVファイル",
            propertyName: "uploadCsvFile",
            schema: {
                schemaType: "file",
            },
        },
    ],
});
exports.getUploadSchema = getUploadSchema;
